import { match } from 'ts-pattern';
import { useNote, useNoteUser } from "../../data/notes";
function getCardStyle(_ref) {
  var noteUser = _ref.noteUser,
    note = _ref.note;
  /*
    Five cases in the creatorPersona field currently:
     - applicant (could be RP or student so need a further check on user role for backward compatibility.
     eventually this will just be student)
     - applyboard_automation i.e. abbie
     - applyboard_support_team i.e. applyboard staff
     - rp_staff i.e. RP staff
     - rp_owner i.e. RP owner
  */
  return match(note.creatorPersona)["with"]('applicant', function () {
    if ((noteUser === null || noteUser === void 0 ? void 0 : noteUser.role) === 'student') {
      return {
        intent: 'positive'
      };
    }
    return {
      intent: 'secondary'
    };
  })["with"]('rp_staff', function () {
    return {
      intent: 'secondary'
    };
  })["with"]('rp_owner', function () {
    return {
      intent: 'secondary'
    };
  })["with"]('applyboard_automation', function () {
    return {
      intent: 'magic'
    };
  })["with"]('applyboard_support_team', function () {
    return {
      intent: undefined
    };
  }).exhaustive();
}
export function useCardStyle(noteId) {
  var _useNote = useNote(noteId),
    note = _useNote.applicationNote;
  var _useNoteUser = useNoteUser(note.legacyCreatorId),
    noteUser = _useNoteUser.noteUser;
  return getCardStyle({
    note: note,
    noteUser: noteUser
  });
}